<template>
    <el-container id="tab">
        <el-aside :width="isCollapse ? '20px' : '220px'">
            <el-card v-show="!isCollapse" class="box-card" shadow="never">
                <el-tabs v-model="activeName" type="card">
                    <el-tab-pane label="片区" name="area">
                        <el-cascader-panel ref="area" v-model="areaSelect" v-loading="areaLoading" :options="areaData" @expand-change="handleExpandChange" @change="handleChange" :props="{label: 'domainDesc',value: 'id',children: 'secondList' }">
                            <template slot-scope="{ data }">
                                <div class="item-left" slot="reference">
                                    <p>{{ data.domainDesc }}</p>
                                </div>
                            </template>
                        </el-cascader-panel>
                    </el-tab-pane>
                    <el-tab-pane label="类别" name="type">
                        <el-cascader-panel ref="type" v-model="typeSelect" v-loading="typeLoading" :options="typeData" @change="handleTypeChange" :props="{label: 'classifyName',value: 'id'}">
                            <template slot-scope="{ data }">
                                <div class="item-left" slot="reference">
                                    <p>{{ data.classifyName }}</p>
                                </div>
                            </template>
                        </el-cascader-panel>
                    </el-tab-pane>
                </el-tabs>
                <el-button style="position: absolute; top: 8px;right: 20px; padding: 0;" icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
            </el-card>
            <div class="isCollapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
                <span style="text-align: center;">{{activeName == 'area' ? '片区' : '类别'}}</span>
                <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
                <span style="text-align: center;">查询</span>
            </div>
        </el-aside>
        <el-main>
            <el-tabs type="border-card" v-model="tabsName" @tab-click="handleClick" class="tabs-card">
                <el-card shadow="never" class="form-box">
                    <div class="form-box-left">
                        <el-form ref="queryInfo" :model="queryInfo" size="small" label-position="right">
                            <el-form-item label="起止时间" prop="billDate.selected" v-if="tabsName != 'A'">
                                <date-picker style="width: 230px;" v-model="queryInfo.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :clearable="false">
                                </date-picker>
                                <el-dropdown @command="handleCommand" v-if="tabsName == 'B'">
                                    <el-button plain style="font-size: 14px; padding: 8px 6px;margin-left: 10px; width: 102px;" class="el-dropdown-link">
                                        {{commandList[commandIndex].name}}<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="item in commandList" :command="item.type" :key="item.type">{{item.name}}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-button type="primary" style="padding: 8px 12px;margin-left: 10px;" @click="onSubmit">查询</el-button>
                            </el-form-item>
                            <el-form-item prop="financialBrandID.selected" :style="{marginTop: tabsName != 'A' ? '6px' : ''}">
                                <select-multiple v-bind:select-data="queryInfo.financialBrandID" isClear isScroll style="width: 160px;"></select-multiple>
                                <el-checkbox v-model="queryInfo.isFilterBalance.selected" true-label="Y" false-label="N" style="margin-left: 40px;" v-if="tabsName == 'A'">余额不为0</el-checkbox>
                                <el-input v-model="queryInfo.keyWords.selected" v-if="tabsName != 'A'" clearable style="width: 180px;margin-left: 10px;" placeholder="支持助记码查询"></el-input>
                                <el-button style="padding: 8px 12px;margin-left: 10px;" v-if="tabsName != 'A'" @click="resetForm">重置</el-button>
                                <el-button style="padding: 8px 12px;margin-left: 10px;" v-if="tabsName != 'A'" type="success" @click="exportExcel">导出</el-button>
                            </el-form-item>
                            <el-form-item prop="financialBrandID.selected" style="margin-top: 6px;" v-if="tabsName == 'A'">
                                <el-input v-model="queryInfo.keyWords.selected" style="width: 180px;" placeholder="支持助记码查询" clearable></el-input>
                                <el-button type="primary" style="padding: 8px 12px;margin-left: 10px;" @click="onSubmit">查询</el-button>
                                <el-button style="padding: 8px 12px;margin-left: 10px;" @click="resetForm">重置</el-button>
                                <el-button style="padding: 8px 12px;margin-left: 10px;" type="success" @click="exportExcel">导出</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="form-box-right">
                        <p v-if="tabsName == 'A'">截止到今日余额合计: {{balanceObj.balanceAmt}}</p>
                        <p v-if="tabsName != 'C'">截止到今日应收合计: {{balanceObj.arrearAmt}}</p>
                        <p v-if="tabsName == 'B'">截止到今日已结算应收: {{balanceObj.checkAmt}}</p>
                        <p v-if="tabsName == 'B'">截止到今日待结算应收: {{balanceObj.unCheckAmt}}</p>
                        <p v-if="tabsName != 'B'">截止到今日预收合计: {{balanceObj.prePayAmt}}</p>
                    </div>
                </el-card>
                <el-tab-pane :label="item.text" :name="item.value" v-for="item in tabPaneList" :key="item.value">
                    <order-table :tag="item.value" :args="queryForm" :ref="'orderTable'+item.value" @billDetailOpen="billDetailOpen"></order-table>
                </el-tab-pane>
            </el-tabs>
        </el-main>
        <el-dialog width="80%" title="" class="bill-detail-dialog" :visible.sync="billDetailVisible" append-to-body @close="billDetailClose">
            <bill-detail ref="billDetailDialog" :visible.sync="billDetailVisible"></bill-detail>
        </el-dialog>
    </el-container>
</template>
<script>
import datePicker from '@/components/common/datePicker.vue'
import orderTable from '@/components/salPayBalance/orderTable.vue'
import billDetail from '@/components/salPayBalance/billDetail.vue'
import { pickerOptions, getNowFormatDate, getAddDate, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
    name: "PayBalance",
    components: {
        datePicker,
        orderTable,
        billDetail
    },
    data() {
        return {
            isCollapse: false,
            loading: false,
            activeName: 'area',
            areaSelect: ['', ''],
            areaData: [],
            areaLoading: false,
            typeLoading: false,
            typeSelect: [''],
            typeData: [],
            typeList: [],
            cascaderKey: 1,
            tabsName: 'A',
            queryInfo: {
                billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
                financialBrandID: { submitName: 'financialBrandID', selected: '', isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 10 }, text: '', value: '' } },
                keyWords: { submitName: 'keyWords', selected: '' },
                isFilterBalance: { submitName: 'isFilterBalance', selected: 'Y' }
            },
            pickerOptions: pickerOptions,
            commandList: [{
                type: '',
                name: '全部'
            }, {
                type: 'N',
                name: '未完成结算'
            }, {
                type: 'Y',
                name: '已完成结算'
            }],
            commandIndex: 0,
            tabPaneList: [{
                text: '余额',
                value: 'A'
            }, {
                text: '应收款',
                value: 'B'
            }, {
                text: '预收款',
                value: 'C'
            }],
            balanceObj: {
                prePayAmt: 0,
                arrearAmt: 0,
                balanceAmt: 0,
                checkAmt: 0,
                unCheckAmt: 0,
            },
            queryForm: {
                financialBrandID: '',
                domainID: '',
                smallDomainID: '',
                classifyID: '',
                beginDate: getAddDate(-3),
                endDate: getNowFormatDate(),
                keyWords: '',
                isCheck: '',
                isFilterBalance: 'Y'
            },
            billDetailVisible: false,
        }
    },
    created() {
        this.getAreaData()
        this.getCustomerTypeData()
        this.getPayBalanceBase()
        this.$nextTick(() => {
            let info = this.$refs['orderTable' + this.tabsName][0]
            info.getTableData()
        })
    },
    watch: {},
    methods: {
        async getAreaData() {
            this.areaLoading = true
            const { data: res } = await this.$http.post('/Account/domainDefineVue/selectDomainTreeList.html')
            this.areaLoading = false
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.areaData = JSON.parse(res.result.data)
            if (this.areaData.length == 0) {
                let _item = {
                    domainDesc: '全部',
                    id: '',
                    isShowAdd: true,
                    domainLevel: '1',
                }
                this.areaData.push(_item)
            }
            this.areaData.map((item, index) => {
                item.index = index
                if (item.secondList) {
                    item.secondList.unshift({ domainDesc: '全部', id: '', domainLevel: '2', customerCount: item.customerCount, isShowAdd: true, parentDomainID: item.id ? item.id : '' })
                } else {
                    // console.log(item.customerCount)
                    item['secondList'] = [{ domainDesc: '全部', id: '', domainLevel: '2', customerCount: item.customerCount, isShowAdd: true, parentDomainID: item.id ? item.id : '' }]
                }
                if (index == 0) {
                    this.areaSelect[0] = ''
                    item.isShowAdd = true
                    item.id = ''
                    item.domainLevel = '1'
                    item.secondList[0].isShowAdd = false
                }
                return item
            })
            // console.log(this.areaData)
        },
        async getCustomerTypeData() {
            this.typeLoading = true
            const { data: res } = await this.$http.post('/Account/customerTypeDefineVue/selectCustomerTypeList.html', this.Qs.stringify({ isAll: 'Y' }))
            this.typeLoading = false
            if (res.code != 'success') return false
            res.result = JSON.parse(res.result)
            this.typeData = JSON.parse(res.result.data).map((item, index) => {
                item.index = index
                if (index == 0) {
                    item.id = ''
                    this.typeSelect[0] = item.id
                    item.isShowAdd = true
                }
                return item
            })
            // console.log(this.typeData)
        },
        async getPayBalanceBase() {
            const { data: res } = await this.$http.post('/Account/SalPayBalanceVue/selectPayBalanceBaseForVue.html')
            if (res.code != 'success') return false
            res.result = JSON.parse(res.result)
            this.balanceObj = JSON.parse(res.result.data)
        },
        handleExpandChange(e) {
            this.areaSelect[0] = e[0]
            // console.log(e)
            if (e[0] == '') {
                this.areaSelect = ['', '']
            }
            this.onSubmit()
        },
        handleChange() {
            this.onSubmit()
        },
        handleTypeChange() {
            this.onSubmit()
        },
        handleClick() {
            this.$nextTick(() => {
                this.tabPaneList.forEach(item => {
                    let info = this.$refs['orderTable' + item.value][0]
                    info.queryInfo.customerID.request.params.page = 1
                    info.queryInfo.customerID.selected = []
                    info.queryInfo.customerID.isFilter = false
                    info.queryInfo.salesmanID.request.params.page = 1
                    info.queryInfo.salesmanID.selected = ''
                    info.queryInfo.salesmanID.isFilter = false
                })
                // if (info.params.customerID) delete info.params.customerID
                // if (info.params.salesmanID) delete info.params.salesmanID
                this.onSubmit()
            })
            // this.onSubmit()
        },
        handleCommand(e) {
            let index = this.commandList.findIndex(item => item.type == e)
            this.commandIndex = index
        },
        onSubmit() {
            let obj = {
                financialBrandID: this.queryInfo.financialBrandID.selected,
                domainID: this.areaSelect[0] || '',
                smallDomainID: this.areaSelect[1] || '',
                classifyID: this.typeSelect[0] || '',
                beginDate: this.queryInfo.billDate.selected[0] || getAddDate(-3),
                endDate: this.queryInfo.billDate.selected[1] || getNowFormatDate(),
                keyWords: this.queryInfo.keyWords.selected,
                isCheck: this.commandList[this.commandIndex].type,
                isFilterBalance: this.queryInfo.isFilterBalance.selected
            }
            if (this.tabsName != 'B') delete obj.isCheck
            this.queryForm = obj
            // console.log(this.queryForm, obj)
            this.$nextTick(() => {
                // console.log(this.$refs['orderTable' + this.tabsName][0])
                let info = this.$refs['orderTable' + this.tabsName][0]
                if (this.tabsName == 'A') {
                    info.pageParams.page = 1
                }
                info.getTableData(true)
            })
        },
        resetForm() {
            this.$refs['queryInfo'].resetFields();
            this.commandIndex = 0
            this.queryInfo.keyWords.selected = ''
            this.queryInfo.billDate.selected = [getAddDate(-3), getNowFormatDate()]
        },
        billDetailOpen(row) {
            // this.billDetailVisible = true
            console.log(row.billType)
            // if (row.billType == 'TZD' || row.billType == 'FYD' || row.billType == 'QC' || row.billType == 'SKD') return false
            if (['TZD', 'FYD', 'QC', 'SKD', 'FHD', 'FOD', 'WLHS', 'WLTF'].includes(row.billType)) return false
            this.billDetailVisible = true
            this.$nextTick(() => {
                let billDetailDialog = this.$refs['billDetailDialog']
                // 获取单据详情事件
                billDetailDialog.getDetailInfo({ billNo: row.soureBillNo, billType: row.billType })
            })
        },
        billDetailClose() {
            this.billDetailVisible = false
            this.$nextTick(() => {
                let billDetailDialog = this.$refs['billDetailDialog']
                // 获取单据详情事件
                billDetailDialog.drawerClose()
            })
        },
        exportExcel() {
            let $tabs = this.$refs['orderTable' + this.tabsName][0]
            let $table = $tabs.$refs.multipleTable
            let params = $tabs.params
            if (this.tabsName != 'B') delete params.isCheck
            let exportExcelUrl = '/Account/SalPayBalanceVue/exportPayBalanceForVue.html'
            if (this.tabsName == 'A') {
                exportExcelUrl = '/Account/SalPayBalanceVue/exportPayBalanceForVue.html'
            } else if (this.tabsName == 'B') {
                exportExcelUrl = '/Account/SalPayBalanceVue/exportArrearList.html'
            } else if (this.tabsName == 'C') {
                exportExcelUrl = '/Account/SalPayBalanceVue/exportPrePayCustomerList.html'
            }
            let tempArr = $table.$children.map(item => {
                if (item.prop && item.prop.match(/\//)) {
                    let label = item.label.split('/')
                    let prop = item.prop.split('/')
                    return [{
                            label: label[0],
                            prop: prop[0]
                        },
                        {
                            label: label[1],
                            prop: prop[1]
                        }
                    ]
                } else {
                    return {
                        label: item.label,
                        prop: item.prop
                    }
                }
            }).filter(item => (item.prop || Array.isArray(item))).flat()
            exportExcelCommonForVue(params, tempArr, exportExcelUrl)
            console.log(params);
            console.log(tempArr)
        }
    }
};
</script>
<style scoped lang="less">
#tab {
    .isCollapse {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        border: 1px #DCDFE6 solid;
        cursor: pointer;
        background-color: rgba(83, 168, 255, 0.1);
        color: #409EFF;
    }

    .box-card {
        height: calc(100% - 2px);
        position: relative;

        /deep/.el-cascader-panel.is-bordered {
            border: none;
        }

        /deep/.el-card__header {
            padding: 8px 20px;
        }

        /deep/.el-tabs__header {
            margin-bottom: 0;
        }

        /deep/.el-card__body {
            padding: 0;
            height: 100%;
        }

        /deep/.el-card__body>div {
            height: 100%;
        }

        /deep/.el-tabs__item {
            line-height: 30px;
            height: 30px;
        }

        /deep/.el-tabs__content {
            padding: 0;
            height: calc(100% - 30px);

            .el-tab-pane {
                padding-top: 0;
                height: 100%;
            }
        }

        /deep/.el-cascader-panel {
            width: 100%;
            height: 100%;
            display: flex;

            .el-icon-check:before {
                content: '';
            }

            .el-cascader-node__postfix {
                display: none;
            }
        }

        /deep/.el-cascader-menu {
            flex: 1;
            min-width: 0;
        }

        /deep/.el-cascader-menu__wrap {
            height: 100%;
            overflow-x: hidden;
        }

        /deep/.el-cascader-node__label {
            width: 100%;
            height: 100%;
            padding: 0;
        }

        /deep/.el-cascader-node {
            padding: 0 10px !important;
        }

        .item-left {
            width: 100%;
            height: 100%;
            position: relative;
        }

        .item-left p {
            font-size: 12px;
            width: 90%;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            margin: 0;
        }

        .item-left .el-badge {
            right: 0;
            font-size: 12px;
            font-weight: normal;
            transform: scale(0.8);
            position: absolute;
        }
    }

    .el-main {
        padding: 0 0 0 12px;
    }

    .tabs-card {
        height: calc(100% - 2px);
        box-shadow: none;
        border-color: #EBEEF5;

        /deep/.el-card__body {
            padding: 8px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .form-box-left {
                flex: 1;
            }

            .form-box-right {
                width: 240px;

                p {
                    font-size: 14px;
                    color: #F56C6C;
                    line-height: 22px;
                }
            }

            .el-form-item {
                margin-bottom: 0;
                margin-right: 0;
            }
        }

        /deep/.el-tabs__item {
            line-height: 32px;
            height: 32px;
        }

        /deep/.el-form-item__content {
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        /deep/.el-tabs__content {
            height: calc(100% - 47px);
            padding: 8px 10px;
        }

        /deep/.el-tab-pane {
            height: calc(100% - 90px);
        }
    }
}

.bill-detail-dialog {
    /deep/.el-dialog__header {
        padding: 0;
    }

    /deep/.el-dialog__body {
        padding: 20px;
        height: 500px;
    }

    /deep/.el-dialog {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        top: 50%;
        transform: translateY(-50%);
    }
}
</style>